// extracted by mini-css-extract-plugin
export default {"loaderIcon":"loader-module--loader-icon--02a51","loadingText":"loader-module--loading-text--0ba6d","loadingWrapper":"loader-module--loading-wrapper--78c71"};